import HomeView from "../views/HomeView";

export default function HomePresenter() {
  return (
    <HomeView/>
  )
}

